<template>
  <Card>
    <View gap="sm" direction="column">
      <View gap="sm" direction="column">
        <Text variant="h4">{{ agentCopy.cardTitle }}</Text>
        <Text variant="body-medium" color="secondary">
          {{ showingAgent ? agentCopy.cardDescription : agentCopy.emptyCardDescription }}
        </Text>
      </View>

      <Card variant="outline-secondary" size="medium">
        <View v-if="showingAgent" gap="sm" justify="space-between">
          <View gap="sm">
            <Avatar :user-name="fullName" />
            <View direction="column" justify="center">
              <Text variant="label-small">{{ fullName }}</Text>
              <Text v-if="showingAgent.phone" variant="body-small" color="secondary">
                {{ formatPhoneNumber(showingAgent.phone) }}
              </Text>
            </View>
          </View>

          <Button variant="outline" size="small" data-manage-action @click="openAssignModal">Edit</Button>
        </View>

        <View v-else gap="sm" justify="space-between" align="center">
          <Text variant="body-medium" color="secondary">{{ agentCopy.emptyAgentLabel }}</Text>

          <Button variant="outline" size="small" data-manage-action @click="openAssignModal">Add</Button>
        </View>
      </Card>
    </View>

    <AssignShowingAgentModal
      ref="assignModalRef"
      :showing-id="showingId"
      :property-id="propertyId"
      :showing-agent-id="showingAgent?.id"
      :tour-type="tourType"
    />
  </Card>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';

import { Avatar, Button, Card, Text, View } from '@tallo/design-system';
import { getShowingAgentCopy, TourType } from '@tallo/investor/showing';
import { ShowingAgentDto } from '@tallo/investor/showing-agents';
import { formatPhoneNumber } from '@tallo/utility';

import AssignShowingAgentModal from './assign-showing-agent-modal.vue';

const props = defineProps<{
  showingId: string;
  // Absent when the showing was booked without one: the card then offers to add it
  showingAgent?: ShowingAgentDto;
  tourType?: TourType;
  propertyId?: string;
}>();

const assignModalRef = ref<InstanceType<typeof AssignShowingAgentModal> | null>(null);
const fullName = computed(() => `${props.showingAgent?.firstName} ${props.showingAgent?.lastName}`);
const agentCopy = computed(() => getShowingAgentCopy(props.tourType, props.showingAgent?.firstName));

function openAssignModal() {
  assignModalRef.value?.open();
}
</script>
